module.exports = __webpack_public_path__ + "img/logo-10.29d8a1ed.png";